import React, { useState } from "react";
import { DataUtilities } from "../../../../rule-engine-core/Common/DataUtilities";
import { ConfirmDialog } from "../../../../CommonUI/ConfirmDialog";
import { ApplyIcon } from "../../../../CommonUI/Icon/ApplyIcon";
import { CloseRedIcon } from "../../../../CommonUI/Icon/CloseRedIcon";
import { DeleteGrayIcon } from "../../../../CommonUI/Icon/DeleteGrayIcon";
import { ObserveState } from "../../../../CommonUI/StateManagement/ObserveState";
import { StateManager } from "../../../../rule-engine-core/Common/StateManager";
import { TestContext } from "../../../../CommonUI/Testing/TestContext";

import {
    RuleTableEmptyAddColumn,
    RuleTableHeaderActionColumn,
    RuleTableIndexColumn,
} from "../../../DesignUI/CommonStyles";
import {
    ITableRowTestValue,
    TableRowTestContext,
} from "../../../../rule-engine-core/Rule/Table/Common/TableRowTestContext";
import { PassedTestRow } from "../../CommonStyles";
import { XResultCell } from "../../CommonUI/XResultCell";
import { RuleTableEditContext } from "../../../../rule-engine-core/Rule/Table/Rule/RuleTableEditContext";
import { RuleTableConfiguration } from "../../../../rule-engine-core/Rule/Table/Rule/RuleTableConfiguration";
import { RuleTableRow } from "../../../../rule-engine-core/Rule/Table/Rule/Structure/RuleTableRow";
import { RuleTableRuleCell } from "./RuleTableRuleCell";

interface RuleTableRowProps {
    ruleDefinition: RuleTableConfiguration;
    rowIndex: number;
    row: RuleTableRow;
    editContext: RuleTableEditContext;
}

export const XRuleTableRow = (props: RuleTableRowProps) => {
    const { rowIndex, ruleDefinition, row, editContext } = props;
    const testContext = React.useContext(TestContext);
    const rowtestitem = testContext?.findItem(row._id);

    const [openConfirmDialog, setOpenConfirmDialog] = useState<boolean>(false);

    let testValue: ITableRowTestValue | undefined;

    if (rowtestitem && !rowtestitem.isError) {
        testValue = rowtestitem.result === "false" ? ITableRowTestValue.FAILED : ITableRowTestValue.PASSED;
    }
    return (
        <TableRowTestContext.Provider value={testValue}>
            {rowtestitem?.result === "true" ? (
                <PassedTestRow
                    data-testid={`passedtestrow`}
                    columnsSpan={ruleDefinition.ruleColumns.length + ruleDefinition.resultColumns.length + 4}
                    y={rowIndex + 2}
                />
            ) : null}
            <RuleTableIndexColumn
                y={rowIndex + 2}
                x={0}
                isTestPassed={testValue === ITableRowTestValue.PASSED}
            >
                {rowtestitem?.result === "true" ? <ApplyIcon /> : null}
                {rowtestitem?.result === "false" ? <CloseRedIcon /> : null}
                {rowIndex + 1}
            </RuleTableIndexColumn>
            {ruleDefinition.ruleColumns.map((col, idx) => (
                <RuleTableRuleCell
                    cell={row.ruleCells[col._id]}
                    rule={col}
                    {...props}
                    key={idx}
                    cellIndex={idx}
                    rowIndex={rowIndex}
                />
            ))}
            <RuleTableEmptyAddColumn
                isTestPassed={testValue === ITableRowTestValue.PASSED}
                y={rowIndex + 2}
                x={ruleDefinition.ruleColumns.length + 1}
            />
            {ruleDefinition.resultColumns.map((col, index2) => {
                return (
                    <ObserveState
                        listenTo={col}
                        key={col._id}
                        control={() => (
                            <XResultCell
                                key={col._id}
                                ruleDefinition={ruleDefinition}
                                editContext={editContext}
                                resultCell={row.resultCellsData[col._id]}
                                resultColumn={col}
                                rowIndex={rowIndex + 2}
                                cellIndex={ruleDefinition.ruleColumns.length + 2 + index2}
                            />
                        )}
                    />
                );
            })}

            <RuleTableEmptyAddColumn
                y={rowIndex + 2}
                x={ruleDefinition.ruleColumns.length + ruleDefinition.resultColumns.length + 2}
            />

            <RuleTableHeaderActionColumn
                y={rowIndex + 2}
                x={ruleDefinition.ruleColumns.length + ruleDefinition.resultColumns.length + 3}
                onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                    if (testContext) return;

                    event.stopPropagation();
                    if (DataUtilities.getCookie("RULE_TABLE_ROW_DELETE") !== "true") {
                        setOpenConfirmDialog(true);
                    } else {
                        ruleDefinition.removeRow(row);
                        StateManager.propertyChanged(ruleDefinition, "rows");
                    }
                }}
            >
                {!testContext && <DeleteGrayIcon />}
            </RuleTableHeaderActionColumn>
            {!testContext && (
                <ConfirmDialog
                    caption="this row"
                    open={openConfirmDialog}
                    onConfirm={(dontAskAgain) => {
                        if (dontAskAgain) {
                            DataUtilities.setCookieValue("RULE_TABLE_ROW_DELETE", "true");
                        }
                        ruleDefinition.removeRow(row);
                        StateManager.propertyChanged(ruleDefinition, "rows");
                        setOpenConfirmDialog(false);
                    }}
                    onCancel={() => setOpenConfirmDialog(false)}
                />
            )}
        </TableRowTestContext.Provider>
    );
};
